import * as actionTypes from './actionTypes';
import * as actions from './index';

export const searchFtvContacts = (filter) => {
    return dispatch => {
        dispatch({ type: actionTypes.FTV_CONTACTS_SEARCH_START });

        window.flow.ftvcontactsSearchUsers(filter).then(res => {
            dispatch({ type: actionTypes.FTV_CONTACTS_SEARCH_SUCCESS, contacts: res});
        }).catch(res => {
            dispatch({ type: actionTypes.FTV_CONTACTS_SEARCH_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const createFtvContact = (contact) => {
    return dispatch => {
        dispatch({ type: actionTypes.FTV_CONTACT_CREATE_START });

        window.flow.ftvcontactsCreateUser(contact).then(res => {
            if(res.msg && res.msg.error) {
                dispatch({ type: actionTypes.FTV_CONTACT_CREATE_FAIL, error: true, save: true });
                dispatch(actions.applicationError(res.msg.error_msg));
                dispatch(actions.addMessage('popup.title.ftv.contact.add.fail', res.msg.error_msg, 'text'));
            } else {
                dispatch({ type: actionTypes.FTV_CONTACT_CREATE_SUCCESS});
                dispatch(actions.searchFtvContacts());
            }
        }).catch(res => {
            dispatch({ type: actionTypes.FTV_CONTACT_CREATE_FAIL, error: false, save: false });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const editFtvContact = (contact, original) => {
    return dispatch => {
        dispatch({ type: actionTypes.FTV_CONTACT_EDIT_START });

        window.flow.ftvcontactsEditUser(contact, original).then(res => {
            if(res.msg && res.msg.error) {
                dispatch({ type: actionTypes.FTV_CONTACT_EDIT_FAIL, error: true, save: true });
                dispatch(actions.applicationError(res.msg.error_msg));
                dispatch(actions.addMessage('popup.title.ftv.contact.edit.fail', res.msg.error_msg, 'text'));
            } else {
                dispatch({ type: actionTypes.FTV_CONTACT_EDIT_SUCCESS});
                dispatch(actions.searchFtvContacts());
            }
        }).catch(res => {
            dispatch({ type: actionTypes.FTV_CONTACT_EDIT_FAIL, error: false, save: false });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const ftvClearError = (id) => {
    return dispatch => {
        dispatch({ type: actionTypes.FTV_CLEAR_ERROR });
    };
};

export const ftvContactsSetRoom = (id) => {
    return dispatch => {
        dispatch({ type: actionTypes.FTV_CONTACTS_SET_ROOM, room: id });
    };
};

export const deleteFtvContact = (contact) => {
    return dispatch => {
        dispatch({ type: actionTypes.FTV_CONTACT_DELETE_START });

        window.flow.ftvcontactsDeleteUser(contact).then(res => {
            dispatch({ type: actionTypes.FTV_CONTACT_DELETE_SUCCESS});
            dispatch(actions.searchFtvContacts());
        }).catch(res => {
            dispatch({ type: actionTypes.FTV_CONTACT_DELETE_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const getFtvGroups = () => {
    return dispatch => {
        dispatch({ type: actionTypes.FTV_GROUPS_SEARCH_START });

        window.flow.ftvcontactsGetGroups({}).then(res => {
            dispatch({ type: actionTypes.FTV_GROUPS_SEARCH_SUCCESS, groups: res});
        }).catch(res => {
            dispatch({ type: actionTypes.FTV_GROUPS_SEARCH_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const getFtvGroup = (group) => {
    return dispatch => {
        dispatch({ type: actionTypes.FTV_GROUP_GET_START });

        window.flow.ftvcontactsGetGroup(group).then(res => {
            dispatch({ type: actionTypes.FTV_GROUP_GET_SUCCESS, group: res});
        }).catch(res => {
            dispatch({ type: actionTypes.FTV_GROUP_GET_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const createFtvGroup = (group) => {
    return dispatch => {
        dispatch({ type: actionTypes.FTV_GROUP_CREATE_START });
        
        window.flow.ftvcontactsCreateGroup(group).then(res => {
            dispatch({ type: actionTypes.FTV_GROUP_CREATE_SUCCESS});
            dispatch(actions.getFtvGroups());
        }).catch(res => {
            dispatch({ type: actionTypes.FTV_GROUP_CREATE_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const deleteFtvGroup = (group) => {
    return dispatch => {
        dispatch({ type: actionTypes.FTV_GROUP_DELETE_START });

        window.flow.ftvcontactsDeleteGroup(group).then(res => {
            dispatch({ type: actionTypes.FTV_GROUP_DELETE_SUCCESS});
            dispatch(actions.getFtvGroups());
        }).catch(res => {
            dispatch({ type: actionTypes.FTV_GROUP_DELETE_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const saveFtvGroup = (group) => {
    return dispatch => {
        dispatch({ type: actionTypes.FTV_GROUP_SAVE_START });

        window.flow.ftvcontactsEditGroup(group).then(res => {
            dispatch({ type: actionTypes.FTV_GROUP_SAVE_SUCCESS, group: group });
            dispatch(actions.getFtvGroups());
        }).catch(res => {
            dispatch({ type: actionTypes.FTV_GROUP_SAVE_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const addFtvToGroup = (gid, uid) => {
    return dispatch => {
        dispatch({ type: actionTypes.FTV_GROUP_ADD_START });

        window.flow.ftvcontactsAddGroupUser({gid: gid, uid: uid}).then(res => {
            dispatch({ type: actionTypes.FTV_GROUP_ADD_SUCCESS});
            dispatch(actions.getFtvGroup({ gid: gid }));
        }).catch(res => {
            dispatch({ type: actionTypes.FTV_GROUP_ADD_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const removeFtvFromGroup = (gid, uid) => {
    return dispatch => {
        dispatch({ type: actionTypes.FTV_GROUP_REMOVE_START });

        window.flow.ftvcontactsRemGroupUser({gid: gid, uid: uid}).then(res => {
            dispatch({ type: actionTypes.FTV_GROUP_REMOVE_SUCCESS});
            dispatch(actions.getFtvGroup({ gid: gid }));
        }).catch(res => {
            dispatch({ type: actionTypes.FTV_GROUP_REMOVE_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const ftvCsvUsers = () => {
    return dispatch => {
        dispatch({ type: actionTypes.FTV_LOAD_CSV_USERS_START });
        window.flow.ftvCsvUsers().then(res => {
            dispatch({ type: actionTypes.FTV_LOAD_CSV_USERS_SUCCESS, users: res});
        }).catch(res => {
            dispatch({ type: actionTypes.FTV_LOAD_CSV_USERS_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const ftvCsvFiles = () => {
    return dispatch => {
        dispatch({ type: actionTypes.FTV_LOAD_CSV_FILES_START });
        window.flow.ftvCsvFiles().then(res => {
            dispatch({ type: actionTypes.FTV_LOAD_CSV_FILES_SUCCESS, files: res});
        }).catch(res => {
            dispatch({ type: actionTypes.FTV_LOAD_CSV_FILES_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};
